import * as yup from 'yup'

const schema = yup.object().shape({
  acceptCreditCheck: yup.boolean().required().oneOf([true]),
  confirmAll: yup.boolean().required().oneOf([true]),
})

export { schema }